<template>
    <el-card shadow="always"
             class="lean">
        <div slot="header"
             class="clearfix">
            <strong class="text-md">Services Health Check</strong>
        </div>
        <div>
            <el-table :data="healthItems"
                      :show-header="false"
                      class="w-full">
                <el-table-column>
                    <template v-slot="scope">
                        <span class="text-blackish">{{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="100"
                                 prop="value">
                    <template v-slot="scope">
                        <div class="text-center">
                            <span v-if="typeof health[scope.row.value] !== 'boolean' && health[scope.row.value]"
                                  class="text-success">{{ health[scope.row.value] }}</span>
                            <span v-else-if="typeof health[scope.row.value] === 'boolean' && health[scope.row.value]"
                                  class="text-success">
                                <i class="material-icons">check</i>
                            </span>
                            <span v-else class="text-danger">
                                <i class="material-icons">close</i>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-card>
</template>

<script>
    export default {
        data() {
            return {
                health: '',
                healthItems: [
                    {title: 'Log Directory Writable', value: 'logDirectoryWritable'},
                    {title: 'Can Connect To Database', value: 'canConnectToDatabase'},
                    {title: 'Can Connect To Twilio', value: 'canConnectToTwilio'},
                    // { title: 'Can Connect To Branch', value: 'branch' },
                    {title: 'Fake Number Purchase', value: 'FAKE_NUMBER_PURCHASE'}
                ],
                loading: false
            }
        },
        created() {
            this.loading = true
            this.getHealth()
            // ping health every 10 seconds
            this.$options.health_interval = setInterval(this.getHealth, 10000)
        },
        methods: {
            getHealth() {
                this.loading = true
                axios.get('/health').then(res => {
                    this.health = res.data
                    this.loading = false
                }).catch(err => {
                    this.$root.handleErrors(err.response)
                    this.loading = false
                })
            }
        },
        beforeDestroy() {
            clearInterval(this.$options.health_interval)
        }
    }
</script>
